;(function() {

	document.addEventSelectorListener("change", "[data-not-reveal]", function(event, target) {
		let isChecked = target.checked;
		let elements = document.querySelectorAll(target.getAttribute("data-not-reveal"));
		for (let element of elements) {
			element.classList.toggle("d-none", isChecked);
		}
	});

	// document.addEventSelectorListener("change", "[data-accordion]", function(event, self) {
	// 	let targets = document.querySelectorAll("[data-" + self.getAttribute("data-accordion") + "='" + self.value + "']");
	// 	let others = document.querySelectorAll("[data-" + self.getAttribute("data-accordion") + "]");

	// 	for (let other of others) {
	// 		other.classList.add("d-none");
	// 	}
	// 	for (let target of targets) {
	// 		target.classList.remove("d-none");
	// 	}

	// 	for (let other of others) {
	// 		let inputs = other.querySelectorAll("input[type='radio']");
	// 		for (let input of inputs) {
	// 			input.checked = false;
	// 		}
	// 	}
	// 	for (let target of targets) {
	// 		let input = target.querySelector("input[type='radio']");
	// 		if (input) {
	// 			input.checked = true;
	// 		}
	// 	}

	// });

/*
	$("[data-not-reveal]").change(function(event) {
		var $this = $(this);
		var isChecked = $this.is(":checked");
		var $target = $($this.data("notReveal"));

		if (isChecked) {
			$target.addClass("d-none");
		} else {
			$target.removeClass("d-none");
		}
	});

	$("[data-accordion]").change(function(event) {
		var $this = $(this);
		var $target = $("[data-" + $this.data("accordion") + "=" + $this.attr("value") + "]");
		var $others = $("[data-" + $this.data("accordion") + "]");

		$others.addClass("d-none");
		$target.removeClass("d-none");

		$others.find("input[type='radio']").prop("checked", false);
		$target.find("input[type='radio']").first().prop("checked", true);
	});

	$("[data-radio-reveal]").change(function(event) {
		var $this = $(this);
		var $target = $($this.data("radioReveal"));
		var $parent = $($this.data("radioRevealParent"));
		var $others = $($this.data("radioRevealOthers"));

		if ($target.length) {
			$others.addClass("d-none");
			$target.removeClass("d-none");
			$parent.removeClass("d-none");
		}
		else {
			$others.addClass("d-none");
			$parent.addClass("d-none");
		}
	});
*/

}());